import FHHeading from './FHHeading.vue';
export default FHHeading
